// extracted by mini-css-extract-plugin
export default {"hidden-label":"EO4Bus","hiddenLabel":"EO4Bus","disclaimers-text":"GjAmtM","disclaimersText":"GjAmtM"};